import { PageViewsInterface } from '../../..';

export class PageViewsDto implements PageViewsInterface{
  webViews?: number;
  mobileViews?: number;
}
